import request from './request';

const ReportService = {
  getOrdersReport: (params) =>
    request.get('dashboard/admin/reports/orders', { params }),
  getProductsReport: (params) =>
    request.get('dashboard/admin/reports/products', { params }),
  getStocksReport: (params) =>
    request.get('dashboard/admin/reports/stocks', { params }),
  /** Paginated product rows behind the stock buckets. Filter with `actual`. */
  getStocksReportPaginate: (params) =>
    request.get('dashboard/admin/stocks/report/paginate', { params }),
  getReportsOverview: (params) =>
    request.get('dashboard/admin/reports/overview', { params }),
  getReportsRevenue: (params) =>
    request.get('dashboard/admin/reports/revenue', { params }),
  /**
   * Where the money came from: revenue and customers by channel, source,
   * campaign and landing page. Paid orders only unless `includeAllStatuses`.
   */
  getReportsAcquisition: (params) =>
    request.get('dashboard/admin/reports/acquisition', { params }),
  /**
   * Whether customers come back. The range picks whose first order counts; each
   * of those customers is then followed for as long as they have existed.
   */
  getReportsRetention: (params) =>
    request.get('dashboard/admin/reports/retention', { params }),
  /** What customers typed into the search box, and what returned nothing. */
  getReportsSearchTerms: (params) =>
    request.get('dashboard/admin/reports/search-terms', { params }),
  /** What was looked at against what was bought. */
  getReportsProductEngagement: (params) =>
    request.get('dashboard/admin/reports/product-engagement', { params }),
  /** Baskets that reached checkout and never became an order. */
  getReportsAbandonedCarts: (params) =>
    request.get('dashboard/admin/reports/abandoned-carts', { params }),
  getReportsCategories: (params) =>
    request.get('dashboard/admin/reports/categories', { params }),
  getReportsExtrasVariations: (params) =>
    request.get('dashboard/admin/reports/extras-variations', { params }),
};

export default ReportService;
